import { render } from "./VerifyAdvert.vue?vue&type=template&id=3545fc6f&scoped=true"
import script from "./VerifyAdvert.vue?vue&type=script&lang=js"
export * from "./VerifyAdvert.vue?vue&type=script&lang=js"

import "./VerifyAdvert.vue?vue&type=style&index=0&id=3545fc6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3545fc6f"]])

export default __exports__